import { AxiosRequestConfig } from "axios";
import { logger } from "../helpers/log-helpers";
import axios from "../libs/axios/axios-reports";
import type { QueryFunction, QueryResult } from "../types/API";
import type { ReportData, ReportFilters } from "../types/documents/Report";

const query: QueryFunction<ReportData, ReportFilters> = async (
  body,
  signal
) => {
  const { propertyName, ...dateRange } = body.query ?? {};
  let path = "/";
  if (propertyName) path += propertyName;

  const options: AxiosRequestConfig = { signal, params: dateRange };

  const { data } = await axios.get<QueryResult<ReportData>>(path, options);
  return data;
};

const addProject = async (projectName: string) => {
  try {
    const response = await axios.post("project", { projectName });
    return response.data;
  } catch (e: any) {
    const message = logger.error(e);
    return Promise.reject(e.response?.data?.error ?? message);
  }
};

export const api = {
  query,
  addProject,
};
